import {Component, OnInit} from "@angular/core";

import {TransferService} from "../../data/transfer.service";

import {TransferHistory} from "../../models/History/transfer.history";
import {TransferHistoryDetails} from "../../models/History/transfer-history-details.model";
import {finalize} from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-transfer-notifications",
    templateUrl: "./transfers.component.html",
    styleUrls: ["./transfers.component.css"]
})
export class TransfersComponent implements OnInit {

    // region dataCarrier

    private _transferRecords: TransferHistory = {
        pageNumber: 1,
        totalRecords: 0,
        data: [] as TransferHistoryDetails[]
    };

    get transferRecords(): TransferHistory {
        return this._transferRecords;
    }

    set transferRecords(value: TransferHistory) {
        this._transferRecords = value;
        this.pageNumber = value.pageNumber || 1;
        this.totalRecords = value.totalRecords;
    }

    // endregion

    buttonValue: number;

    transferType = []

    isLoading: boolean;

    // region pageController

    pageNumber = 1;
    totalRecords = 0;
    // * Default value
    pageSize = 50;


    // region Range
    from = 1;
    to = this.totalRecords;
    // endregion

    // endregion

    constructor(
        private historyClient: TransferService,
        private translateService: TranslateService
    ) {
      this.transferType = [
        {
          name: translateService.instant("Transfers.Everything"),
          value: 0
        },
        {
            name: translateService.instant("Transfers.Sent"),
            value: 18
        },
        {
            name: translateService.instant("Transfers.GotIt"),
            value: 19
        }
      ]
    }

    async ngOnInit() {
        await this.onSearch(0);
    }

    async fillTransfers(transferType: number) {

        this.buttonValue = transferType;

        this.isLoading = true;

        this.transferRecords = await this.historyClient
            .search(this.pageNumber, this.pageSize, transferType).pipe(
                finalize(
                    () => {
                        this.isLoading = false;
                    }
                )
            )
            .toPromise();
    }

    async onPrevious() {
        // this.pageNumber.next();
        this.pageNumber--;

        this.from = this.from - this.pageSize;
        if (this.to === this.totalRecords) {
            this.to = this.to - (this.totalRecords - this.pageSize * this.pageNumber);
        } else {
            this.to = this.to - this.pageSize;
        }

        await this.fillTransfers(this.buttonValue);
    }

    async onNext() {
        this.pageNumber++;

        this.from = this.from + this.pageSize;
        if (this.to + this.pageSize >= this.totalRecords) {
            this.to = this.totalRecords;
        } else {
            this.to = this.to + this.pageSize;
        }

        await this.fillTransfers(this.buttonValue);
    }

    async onSearch(value: number) {
        await this.fillTransfers(value);
        if (this.pageSize > this.totalRecords) {
            this.to = this.totalRecords;
        } else {
            this.to = this.pageSize;
        }
    }
}
